import { cn } from '~/utils/tailwind-utils'

interface WorldChainIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const WorldChainIcon: React.FC<WorldChainIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 179 179"
      fill="none"
      className={cn(colored && 'fill-[#33312E] dark:fill-white', className)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M134.322 12.0548C120.565 4.11049 105.672 0 89.5 0C73.3282 0 58.4386 3.97055 44.6784 12.0548C30.9182 20.1391 20.1391 30.9182 12.0548 44.6784C3.97055 58.4354 0 73.3282 0 89.5C0 105.672 3.97055 120.561 12.0548 134.322C20.1391 148.079 30.9182 158.861 44.6784 166.945C58.4386 175.029 73.3282 179 89.5 179C105.672 179 120.561 175.029 134.322 166.945C148.082 158.861 158.861 148.082 166.945 134.322C175.029 120.565 179 105.672 179 89.5C179 73.3282 175.029 58.4386 166.945 44.6784C158.861 30.9182 148.082 20.1391 134.322 12.0548ZM95.0327 121.84C84.9632 121.84 76.8789 119.002 70.6367 113.19C66.383 109.219 63.6882 104.396 62.2692 98.7234H158.721C157.728 106.951 155.317 114.609 151.629 121.844H94.8928H95.036L95.0327 121.84ZM62.4092 80.563C63.6849 75.0303 66.5229 70.2103 70.6367 66.2365C76.7357 60.4206 84.9632 57.4427 95.0327 57.4427H152.052C155.74 64.6776 158.008 72.3355 158.861 80.563H62.4092ZM29.0761 53.8985C35.3183 43.1195 43.6858 34.6088 54.3249 28.2267C64.964 21.8445 76.7357 18.7234 89.5 18.7234C102.264 18.7234 114.039 21.8445 124.675 28.2267C130.065 31.4877 135.028 35.3183 139.285 39.7152H94.18C83.9673 39.7152 74.8904 41.8437 66.946 46.0974C59.0017 50.3511 52.7627 56.1669 48.3658 63.6849C45.2447 68.9345 43.2594 74.6072 42.41 80.7062H20.2823C21.4182 71.2029 24.2529 62.266 29.0761 54.0417V53.8985ZM124.675 150.773C114.036 157.155 102.264 160.277 89.5 160.277C76.7357 160.277 64.9607 157.155 54.3249 150.773C43.6858 144.391 35.1751 135.881 29.0761 125.101C24.3961 117.017 21.4182 108.223 20.2823 98.8601H42.41C43.2594 104.959 45.2479 110.632 48.3658 115.881C52.7627 123.256 59.0049 129.215 66.946 133.469C74.8904 137.723 83.9673 139.851 94.18 139.851H138.858C134.605 144.105 129.921 147.795 124.675 150.913V150.77V150.773Z"
        fill={colored ? undefined : 'currentColor'}
      />
    </svg>
  )
}
